import * as signals from "@/signals";
import { NoteInfo } from "@/types";

export function getNewNoteTemplate(): NoteInfo {
	return {
		content: "",
		createdAt: new Date().toISOString(),
		id: "new-note",
		isPinned: false,
		itemType: "txt",
		modifiedAt: new Date().toISOString(),
		title: "",
		username: signals.login.value.username || "",
	};
}
